import React from "react";
import useAuthContext from "../../../hooks/useAuthContext";
import { listStyle, listItemStyle, labelStyle } from "./styles";

const env = location.origin;
const prod =  'https://app.fileops.com'
const staging =  'https://appstaging.fileops.com'
const About = () => {
  const { appInfo } = useAuthContext();

  return (
    <div>
      <h3>FileOps</h3>
      <ul className={listStyle}>
        <li className={listItemStyle}>
          <div className={labelStyle}>Client Version:</div>
          <div>{appInfo?.addInVersion}</div>
        </li>
        <li className={listItemStyle}>
          <div className={labelStyle}>Server Version:</div>
          <div>{appInfo?.webApiVersion}</div>
        </li>
        {/* <li className={listItemStyle}>
          <div className={labelStyle}>Function App Version:</div>
          <div>{appInfo?.functionAppVersion}</div>
        </li> */}
        {env !==staging && env !==prod? (
      <li className={listItemStyle}>
          <div className={labelStyle}>{env}</div></li>):null}
      </ul>
    </div>
  );
};

export default About;
